import { useEffect, useRef } from 'react';
import { Icon } from './Icons';

export function PrivacyPanel({ open, onClose }: { open: boolean; onClose: () => void }) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog ref={dialogRef} className="privacy-dialog" onClose={onClose} onCancel={onClose}>
      <div className="privacy-dialog__header">
        <div><span className="eyebrow">Website information</span><h2>Privacy notice</h2></div>
        <button type="button" onClick={onClose} aria-label="Close privacy notice"><Icon name="x" /></button>
      </div>
      <div className="privacy-copy">
        <p className="privacy-updated">Last updated: 18 July 2026</p>
        <p>This notice explains how Echosol Solutions Ltd handles personal information when you visit this informational website or contact us by email.</p>
        <h3>Who we are</h3>
        <p>Echosol Solutions Ltd is a private company registered in Scotland under company number SC896357. For website privacy enquiries, email <a href="mailto:contact@echosol.co.uk">contact@echosol.co.uk</a>.</p>
        <h3>Information this site uses</h3>
        <p>This version of the website does not use analytics, advertising trackers, user accounts or non-essential cookies. Our hosting provider may process basic technical request logs, such as IP address, browser information and request time, to deliver and secure the site.</p>
        <h3>When you contact us</h3>
        <p>If you email us, we receive the information in your message and your contact details. We use it to respond, manage the enquiry, protect our legal interests and maintain appropriate business records. The lawful basis will normally be legitimate interests, steps requested before a contract, or a legal obligation, depending on the enquiry.</p>
        <h3>Sharing and retention</h3>
        <p>Information may be handled by our email and website-hosting providers, or disclosed where legally required. We retain correspondence only for as long as reasonably needed for the enquiry, legal obligations and the establishment or defence of claims.</p>
        <h3>Your rights</h3>
        <p>Depending on the circumstances, UK data-protection law may give you rights to access, correct, erase or restrict personal data, object to processing, and receive certain data in portable form. You may also complain to the UK Information Commissioner's Office.</p>
        <h3>Separate Group Upp policy</h3>
        <p>The Group Upp application processes additional account, group, content and gameplay information. Its in-app privacy policy applies to that processing and should be reviewed separately before using the application.</p>
        <p className="privacy-note">This notice must be reviewed before adding analytics, embedded forms, advertising, new hosting services or other tracking technology.</p>
      </div>
    </dialog>
  );
}
